"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBondAndSellToOffers = void 0;
const common_1 = require("../../../../common");
const constants_1 = require("../../../constants");
const constants_2 = require("../../../constants");
const helpers_1 = require("./../../../helpers");
const mpl_token_metadata_1 = require("@metaplex-foundation/mpl-token-metadata");
const anchor_1 = require("@project-serum/anchor");
const token_1 = require("@project-serum/anchor/dist/cjs/utils/token");
const createBondAndSellToOffers = ({ programId, connection, args, addComputeUnits, accounts, sendTxn, }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const program = (0, helpers_1.returnAnchorProgram)(programId, connection);
    const instructions = [];
    const fbond = anchor_1.web3.Keypair.generate();
    const [bondProgramAuthority] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_2.BOND_PROOGRAM_AUTHORITY_PREFIX), fbond.publicKey.toBuffer()], program.programId);
    const [returnFundsOwner] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_2.RETURN_FUNDS_OWNER_PREFIX), fbond.publicKey.toBuffer()], program.programId);
    const [collateralBox] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_2.COLLATERAL_BOX_PREFIX), fbond.publicKey.toBuffer(), constants_1.ENCODER.encode('0')], program.programId);
    const userTokenAccount = yield (0, common_1.findAssociatedTokenAddress)(accounts.userPubkey, accounts.tokenMint);
    const collateralTokenAccount = yield (0, common_1.findAssociatedTokenAddress)(bondProgramAuthority, accounts.tokenMint);
    const editionInfo = (0, helpers_1.getMetaplexEditionPda)(accounts.tokenMint);
    const nftMetadata = (0, helpers_1.getMetaplexMetadata)(accounts.tokenMint);
    const ownerTokenRecord = (0, helpers_1.findTokenRecordPda)(accounts.tokenMint, userTokenAccount);
    const destTokenRecord = (0, helpers_1.findTokenRecordPda)(accounts.tokenMint, collateralTokenAccount);
    const meta = yield mpl_token_metadata_1.Metadata.fromAccountAddress(connection, nftMetadata);
    const ruleSet = (_a = meta.programmableConfig) === null || _a === void 0 ? void 0 : _a.ruleSet;
    const tokenRecordData = meta.tokenStandard === mpl_token_metadata_1.TokenStandard.ProgrammableNonFungible
        ? yield mpl_token_metadata_1.TokenRecord.fromAccountAddress(connection, ownerTokenRecord)
        : { delegate: null };
    const delegatePubkey = tokenRecordData.delegate;
    const [mutualBondTradeTxnVault] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_2.MUTUAL_BOND_TRADE_TXN_VAULT)], program.programId);
    const [hadoRegistry, registrySeed] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_2.HADOMARKET_REGISTRY_PREFIX), accounts.hadoMarket.toBuffer()], program.programId);
    const sellBondParams = yield Promise.all(args.sellBondParamsAndAccounts.map((sellBondParamsAndAccount) => __awaiter(void 0, void 0, void 0, function* () {
        const [bondTradeTransactionV2, bondTradeTransactionBump] = yield anchor_1.web3.PublicKey.findProgramAddress([
            constants_1.ENCODER.encode(constants_2.AUTOCOMPOUND_DEPOSIT_PREFIX),
            fbond.publicKey.toBuffer(),
            sellBondParamsAndAccount.bondOfferV2.toBuffer(),
            constants_1.ENCODER.encode(sellBondParamsAndAccount.minAmountToGet.toString()),
            constants_1.ENCODER.encode(sellBondParamsAndAccount.amountToSell.toString()),
        ], program.programId);
        return {
            minAmountToGet: new anchor_1.BN(sellBondParamsAndAccount.minAmountToGet),
            amountToSell: new anchor_1.BN(sellBondParamsAndAccount.amountToSell),
            bondTradeTransactionBump: bondTradeTransactionBump,
        };
    })));
    const sellBondRemainingAccounts = (yield Promise.all(args.sellBondParamsAndAccounts.map((sellBondParamsAndAccount) => __awaiter(void 0, void 0, void 0, function* () {
        const [bondTradeTransactionV2, bondTradeTransactionBump] = yield anchor_1.web3.PublicKey.findProgramAddress([
            constants_1.ENCODER.encode(constants_2.AUTOCOMPOUND_DEPOSIT_PREFIX),
            fbond.publicKey.toBuffer(),
            sellBondParamsAndAccount.bondOfferV2.toBuffer(),
            constants_1.ENCODER.encode(sellBondParamsAndAccount.minAmountToGet.toString()),
            constants_1.ENCODER.encode(sellBondParamsAndAccount.amountToSell.toString()),
        ], program.programId);
        // console.log('bondTradeTransaction: ', bondTradeTransactionV2.toBase58());
        return [
            {
                pubkey: sellBondParamsAndAccount.bondOfferV2,
                isSigner: false,
                isWritable: true,
            },
            {
                pubkey: bondTradeTransactionV2,
                isSigner: false,
                isWritable: true,
            },
        ];
    })))).flat();
    const modifyComputeUnits = anchor_1.web3.ComputeBudgetProgram.setComputeUnitLimit({
        units: Math.round(800000 + Math.ceil(Math.random() * 10000)),
    });
    const requestHeap = anchor_1.web3.ComputeBudgetProgram.setComputeUnitPrice({ microLamports: 6000 });
    instructions.push(requestHeap);
    if (!!addComputeUnits)
        instructions.push(modifyComputeUnits);
    const accountsIntoInstruction = {
        fbond: fbond.publicKey,
        bondProgramAuthority: bondProgramAuthority,
        user: accounts.userPubkey,
        hadoRegistry: hadoRegistry,
        hadoMarket: accounts.hadoMarket,
        oracleFloor: accounts.oracleFloor,
        whitelistEntry: accounts.whitelistEntry,
        mutualBondTradeTxnVault: mutualBondTradeTxnVault,
        protocolFeeReceiver: accounts.protocolFeeReceiver,
        collateralBox: collateralBox,
        tokenMint: accounts.tokenMint,
        userTokenAccount: userTokenAccount,
        collateralTokenAccount: collateralTokenAccount,
        ownerTokenRecord,
        destTokenRecord,
        nftMetadata,
        instructions: anchor_1.web3.SYSVAR_INSTRUCTIONS_PUBKEY,
        authorizationRulesProgram: constants_1.AUTHORIZATION_RULES_PROGRAM,
        tokenProgram: token_1.TOKEN_PROGRAM_ID,
        associatedTokenProgram: token_1.ASSOCIATED_PROGRAM_ID,
        systemProgram: anchor_1.web3.SystemProgram.programId,
        rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
        metadataProgram: constants_1.METADATA_PROGRAM_PUBKEY,
        editionInfo: editionInfo,
    };
    const remainingAccountsPnft = [
        {
            pubkey: ruleSet || constants_1.METADATA_PROGRAM_PUBKEY,
            isSigner: false,
            isWritable: false,
        },
        {
            pubkey: delegatePubkey || constants_1.METADATA_PROGRAM_PUBKEY,
            isSigner: false,
            isWritable: false,
        },
    ];
    const createAndSellBondRemainingAccounts = [...sellBondRemainingAccounts, ...remainingAccountsPnft];
    instructions.push(yield program.methods
        .createBondAndSellToOffers(sellBondParams)
        .accountsStrict(accountsIntoInstruction)
        .remainingAccounts(createAndSellBondRemainingAccounts)
        .instruction());
    const addressesForLookupTable = [
        ...Object.values(accountsIntoInstruction),
        ...Array.from(createAndSellBondRemainingAccounts, (x) => x.pubkey),
    ];
    const transaction = new anchor_1.web3.Transaction();
    for (let instruction of instructions)
        transaction.add(instruction);
    const signers = [fbond];
    yield sendTxn(transaction, signers);
    return {
        fbond: fbond.publicKey,
        fbondTokenMint: fbond.publicKey,
        collateralBox: collateralBox,
        bondProgramAuthority,
        returnFundsOwner,
        userTokenAccount,
        collateralTokenAccount,
        editionInfo,
        nftMetadata,
        ownerTokenRecord,
        destTokenRecord,
        instructions,
        signers,
        addressesForLookupTable,
    };
});
exports.createBondAndSellToOffers = createBondAndSellToOffers;
